var e={countDownLabel:"Offer ends in"};export{e as summaryTileTranslations};
